import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MainComponent } from './main/main.component';
import { PayloadSimulatorComponent } from './payload-simulator/payload-simulator.component';
import { AdverseNotoficationComponent } from './adverse-notification/adverse-notification.component';
import { GlobalsService } from './common/services/globals.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {APP_BASE_HREF} from '@angular/common';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { HttpConfigInterceptor } from './interceptor/http.interceptor';
import { CookieService } from "angular2-cookie/services/cookies.service";

import * as bootstrap from "bootstrap";
import * as $ from "jquery";
import { SessionErrorComponent } from './session-error/session-error.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { HelpComponent } from './help/help.component';
import { SafePipe } from './main/main.component';

import { SbeComponent } from './sbe/sbe.component';
import { SbeHeaderComponent } from './sbe/header/header.component';
import { SbeFooterComponent } from './sbe/footer/footer.component';
import { DoneComponent } from './done/done.component';
import { DebounceClickDirective } from './debounce-click.directive';

import { NysbeComponent } from './nysbe/nysbe.component';
import { NysbeHeaderComponent } from './nysbe/header/header.component';
import { NysbeFooterComponent } from './nysbe/footer/footer.component';
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainComponent,
    SessionErrorComponent,
    TermsAndConditionsComponent,
    HelpComponent,
    PayloadSimulatorComponent,
    AdverseNotoficationComponent,
    SafePipe,
    SbeComponent,
    SbeHeaderComponent,
    SbeFooterComponent,
    DoneComponent,
    DebounceClickDirective,
    NysbeComponent,
    NysbeHeaderComponent,
    NysbeFooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxSpinnerModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    GlobalsService,
    CookieService,
    {
      provide: APP_BASE_HREF,
      //useValue: '/billing/paynow'
      useValue: '/'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}